import V3API from '@/api/v3';
import { sortAlphabetical } from '@/utils/helpers';

const RESET_BAG = 'RESET_BAG';

const GET_DATA = 'GET_DATA';
const GET_DATA_FAILED = 'GET_DATA_FAILED';
const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';

const CREATE_BAG = 'CREATE_BAG';
const CREATE_BAG_FAILED = 'CREATE_BAG_FAILED';
const CREATE_BAG_SUCCESS = 'CREATE_BAG_SUCCESS';

const CREATE_UPDATE_EMPTY_BAG = 'CREATE_UPDATE_EMPTY_BAG';
const CREATE_UPDATE_EMPTY_BAG_FAILED = 'CREATE_UPDATE_EMPTY_BAG_FAILED';
const CREATE_UPDATE_EMPTY_BAG_SUCCESS = 'CREATE_UPDATE_EMPTY_BAG_SUCCESS';

const GET_USER_BAG = 'GET_USER_BAG';
const GET_USER_BAG_FAILED = 'GET_USER_BAG_FAILED';
const GET_USER_BAG_SUCCESS = 'GET_USER_BAG_SUCCESS';

const CANCEL_USER_BAG = 'CANCEL_USER_BAG';
const CANCEL_USER_BAG_FAILED = 'CANCEL_USER_BAG_FAILED';
const CANCEL_USER_BAG_SUCCESS = 'CANCEL_USER_BAG_SUCCESS';

const GET_USER_BAGS = 'GET_USER_BAGS';
const GET_USER_BAGS_FAILED = 'GET_USER_BAGS_FAILED';
const GET_USER_BAGS_SUCCESS = 'GET_USER_BAGS_SUCCESS';

const CLUB_UPSERT = 'CLUB_UPSERT';
const CLUB_UPSERT_FAILED = 'CLUB_UPSERT_FAILED';
const CLUB_UPSERT_SUCCESS = 'CLUB_UPSERT_SUCCESS';

const GET_USER_CLUB_LIST = 'GET_USER_CLUB_LIST';
const GET_USER_CLUB_LIST_FAILED = 'GET_USER_CLUB_LIST_FAILED';
const GET_USER_CLUB_LIST_SUCCESS = 'GET_USER_CLUB_LIST_SUCCESS';

const RESET_ALL_BAG_CLUB = 'RESET_ALL_BAG_CLUB';

//* Enabled the module to be namespaced
const namespaced = true;

const getDisplayBagClubs = (data) => {
  // console.log('getDisplayBagClubs data:', data);
  return {
    id: data?.id,
    name: data?.name,
    status: data?.status,
    bag_clubs:
      data?.bag_clubs?.map((item) => {
        return {
          bag_id: item?.bag_id,
          club_id: item?.club_id,
          // position: item?.position,
          // id: item?.club?.id,
          name: item?.club?.name,
          club_type_id: item?.club?.club_type_id,
          club_type_name: item?.club?.club_type?.name,
          club_category_id: item?.club?.club_type?.club_category_id,
          club_category_name: item?.club?.club_type?.club_category?.name,
          club_type_abbreviation: item?.club?.club_type?.abbreviation,
          club_loft_options: item?.club?.club_type?.loft_options,
          club_make_name: item?.club?.club_make?.name,
          club_model_name: item?.club?.club_model?.name,
          club_model_img: item?.club?.club_model?.image_url,
          ...item.club,
        };
      }) ?? [],
  };
};

const getDisplayUserClubs = (data) => {
  // console.log('getDisplayUserClubs data:', data);
  return data?.map((club) => {
    return {
      id: club.id,
      name: club?.name,
      status: club.status,
      loft: club?.loft,
      tag: club?.tag,
      notes: club?.notes,
      shaft_flex: club?.shaft_flex,
      // bags: club?.bag_clubs?.length ? club.bag_clubs : null,
      club_abbreviation: club?.club_type?.abbreviation,
      club_type_name: club?.club_type.name,
      club_type_id: club?.club_type.id,
      club_category_name: club?.club_type?.club_category?.name,
      club_category_id: club?.club_type?.club_category_id,
      club_loft_options: club?.club_type?.loft_options,
      club_make_name: club?.club_make?.name,
      club_model_name: club?.club_model?.name,
      club_model_img: club?.club_model?.image_url,
      display_order: club?.club_type?.display_order,
      ...club,
    };
  });
};

// const sortData = (a, b) => {
//   if (a.position < b.position) return -1;
//   if (a.position > b.position) return 1;
//   return 0;
// };

const state = {
  loading: false,
  loadingClub: false,
  loadingClubList: false,
  userBag: null,
  userBags: null,
  userClubList: null,
};

const getters = {
  isLoading: (state) => {
    return state.loading;
  },

  isLoadingClub: (state) => {
    return state.loadingClub;
  },

  userBag: (state) => {
    return state.userBag;
  },

  userBags: (state) => {
    return state.userBags;
  },

  userClubs: (state) => {
    return state.userClubList;
  },

  isLoadingClubList: (state) => {
    return state.loadingClubList;
  },
};

const actions = {
  // * create a default bag with standard clubs for a user
  async createDefaultBag({ commit, dispatch }, payload) {
    let response = {};

    commit(CREATE_BAG);

    try {
      response = await V3API.clubs.createDefaultBag(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(CREATE_BAG_FAILED);
        reject(response);
      } else {
        commit(CREATE_BAG_SUCCESS, response.data);
        dispatch('getUserBagList');
        dispatch('getUserClubList');
        resolve(response.data);
      }
    });
  },

  // @ DEPRECATED ==============
  // * create an empty bag or edit an existing bag for a user
  async upsertBag({ commit, dispatch }, payload) {
    let response = {};

    commit(CREATE_UPDATE_EMPTY_BAG);

    try {
      response = await V3API.clubs.upsertBag(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(CREATE_UPDATE_EMPTY_BAG_FAILED);
        reject(response);
      } else {
        commit(CREATE_UPDATE_EMPTY_BAG_SUCCESS, response.data);
        dispatch('getUserBagList');
        resolve(response.data);
      }
    });
  },

  // * create a bag for a user
  async bagCreate({ commit, dispatch }, payload) {
    let response = {};

    commit(CREATE_UPDATE_EMPTY_BAG);

    try {
      response = await V3API.clubs.bagCreate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(CREATE_UPDATE_EMPTY_BAG_FAILED);
        reject(response);
      } else {
        commit(CREATE_UPDATE_EMPTY_BAG_SUCCESS, response.data);
        dispatch('getUserBagList');
        resolve(response.data);
      }
    });
  },

  // * update a bag for a user
  async bagUpdate({ commit, dispatch }, payload) {
    let response = {};

    commit(CREATE_UPDATE_EMPTY_BAG);

    try {
      response = await V3API.clubs.bagUpdate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(CREATE_UPDATE_EMPTY_BAG_FAILED);
        reject(response);
      } else {
        commit(CREATE_UPDATE_EMPTY_BAG_SUCCESS, response.data);
        dispatch('getUserBagList');
        resolve(response.data);
      }
    });
  },

  // * get list a user's golf bags
  async getUserBagList({ commit }, payload) {
    let response = {};

    commit(GET_USER_BAGS);

    try {
      response = await V3API.clubs.userBagList(payload);

      if (response?.data) {
        response.data = sortAlphabetical(response.data, 'status');
        // TODO maybe sort by created at?
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_USER_BAGS_FAILED);
        reject(response);
      } else {
        commit(GET_USER_BAGS_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * get a user's active golf bag
  async getUserActiveBag({ commit, dispatch }, payload) {
    let response = {};

    commit(GET_USER_BAG);

    try {
      response = await V3API.clubs.userActiveBag(payload);

      response.data = getDisplayBagClubs(response.data);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_USER_BAG_FAILED);
        reject(response);
      } else {
        commit(GET_USER_BAG_SUCCESS, response.data);
        dispatch('getUserBagList');
        resolve(response.data);
      }
    });
  },

  // * get a golf bag details
  async getUserBag({ commit }, payload) {
    let response = {};

    commit(GET_USER_BAG);

    try {
      response = await V3API.clubs.getUserBag(payload);
      response.data = getDisplayBagClubs(response.data);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_USER_BAG_FAILED);
        reject(response);
      } else {
        commit(GET_USER_BAG_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * deselect user bag
  cancelUserBag({ commit }, payload) {
    commit(CANCEL_USER_BAG_SUCCESS);
  },

  // * delete a golf bag
  async bagDelete({ commit, dispatch }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await V3API.clubs.bagDelete(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        dispatch('getUserBagList');
        dispatch('resetUserBag');
        resolve(response.data);
      }
    });
  },

  // * Add club to bag
  async bagAddClub({ commit, dispatch }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await V3API.clubs.bagAddClub(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        dispatch('getUserBag', { id: payload.bag_id });
        dispatch('getUserBagList');
        dispatch('getUserClubList');
        resolve(response.data);
      }
    });
  },

  // * Remove club from bag
  async bagRemoveClub({ commit, dispatch }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await V3API.clubs.bagRemoveClub(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        dispatch('getUserBagList');
        dispatch('getUserBag', { id: payload.bag_id });
        resolve(response.data);
      }
    });
  },

  // * Reset clubs to default in bag
  async bagResetDefault({ commit, dispatch }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await V3API.clubs.bagResetDefault(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        dispatch('getUserBagList');
        dispatch('getUserBag', { id: payload.id });
        resolve(response.data);
      }
    });
  },

  resetUserBag({ commit }) {
    commit(RESET_BAG);
  },

  //* CLUBS =============================================================

  // @ DEPRECATED ==============
  // * Create or edit a club
  async clubUpsert({ commit, dispatch }, payload) {
    let response = {};

    commit(CLUB_UPSERT);

    try {
      response = await V3API.clubs.clubUpsert(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(CLUB_UPSERT_FAILED);
        reject(response);
      } else {
        commit(CLUB_UPSERT_SUCCESS, response.data);
        dispatch('getUserClubList');
        resolve(response.data);
      }
    });
  },

  // * Create a club
  async clubCreate({ commit, dispatch }, payload) {
    let response = {};

    commit(CLUB_UPSERT);

    try {
      response = await V3API.clubs.clubCreate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(CLUB_UPSERT_FAILED);
        reject(response);
      } else {
        commit(CLUB_UPSERT_SUCCESS, response.data);
        dispatch('getUserClubList');
        resolve(response.data);
      }
    });
  },

  // * Update a club
  async clubUpdate({ commit, dispatch }, payload) {
    let response = {};

    commit(CLUB_UPSERT);

    try {
      response = await V3API.clubs.clubUpdate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(CLUB_UPSERT_FAILED);
        reject(response);
      } else {
        commit(CLUB_UPSERT_SUCCESS, response.data);
        dispatch('getUserClubList');
        if (payload?.bag_id) {
          dispatch('getUserBag', { id: payload?.bag_id });
        }
        if (response?.data?.bags?.length) {
          response?.data?.bags?.forEach((bag) => {
            dispatch('getUserBag', { id: bag?.id });
          });
        }
        resolve(response.data);
      }
    });
  },

  //* get club category list
  async getUserClubList({ commit }, payload) {
    let response = {};

    commit(GET_USER_CLUB_LIST);

    try {
      response = await V3API.clubs.userClubList(payload);
      // response.data = sortAlphabetical(getDisplayUserClubs(response.data), 'name');
      if (response?.data?.length) {
        response.data = getDisplayUserClubs(response?.data)?.sort((a, b) => {
          return a?.display_order > b?.display_order ? 1 : -1;
        });
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_USER_CLUB_LIST_FAILED);
        reject(response);
      } else {
        commit(GET_USER_CLUB_LIST_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* get club category list
  async getClubCategories({ commit }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await V3API.clubs.clubCategoryList(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* get club types list
  async getClubTypes({ commit }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await V3API.clubs.clubTypeList(payload);
      // response.data = sortAlphabetical(response.data, 'name'); //* Disable sorting. Done on server
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* get club makes list
  async getClubMakes({ commit }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await V3API.clubs.clubMakeList(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* get club models list
  async getClubModels({ commit }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await V3API.clubs.clubModelList(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * delete a golf club
  async clubDelete({ commit, dispatch }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      response = await V3API.clubs.clubDelete(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        dispatch('getUserClubList');
        dispatch('resetUserBag');
        resolve(response.data);
      }
    });
  },

  //* get club type/category/make/model
  //* Not used
  async getClubOptions({ commit }, payload) {
    let response = {};

    commit(GET_DATA);

    try {
      const clubCategoryRes = await V3API.clubs.clubCategoryList;
      const clubTypeRes = await V3API.clubs.clubTypeList;
      const clubMakeRes = await V3API.clubs.clubMakeList;
      const clubModelRes = await V3API.clubs.clubModelList;
      response = await Promise.all([
        clubCategoryRes(),
        clubTypeRes(),
        clubMakeRes(),
        clubModelRes(),
      ]);

      // const data = await Promise.all(
      //   response.map((r) => {
      //     return { ...r };
      //   })
      // );
      // console.log(data.flat());

      response.data = await Promise.all(
        response.map((r) => {
          // console.log('r:', r);
          if (r.data.length === 5) {
            // clubType = r.data;
            return { clubType: r.data };
          }
          if (r.data[0].club_category_id) {
            // clubCategory = r.data;
            return { clubCategory: r.data };
          }
          if (r.data[0].club_make_id) {
            // clubMake = r.data;
            return { clubMake: r.data };
          }
          // clubModel = r.data;
          Object.assign(r, { clubModel: r.data });
          return { clubModel: r.data };

          // Object.assign(r, { r.data });

          // console.log('clubModel:', clubModel);
          // console.log('clubMake:', clubMake);
          // console.log('clubType:', clubType);
          // console.log('clubCategory:', clubCategory);

          // return { ...r.data };
          // return { clubType, clubCategory, clubMake, clubModel };
        })
      );

      response.status = response?.[3].status;
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * RESET IT ALL
  resetAllBagClub({ commit }) {
    commit(RESET_ALL_BAG_CLUB);
  },
};

// @ MUTATIONS ====================================================================
const mutations = {
  [GET_DATA](state) {
    state.loading = true;
  },

  [GET_DATA_FAILED](state) {
    state.loading = false;
  },

  [GET_DATA_SUCCESS](state, data) {
    state.loading = false;
  },

  [CREATE_BAG](state) {
    state.loading = true;
  },

  [CREATE_BAG_FAILED](state) {
    state.loading = false;
  },

  [CREATE_BAG_SUCCESS](state, data) {
    state.loading = false;
    // state.userBag = data;
  },

  [CREATE_UPDATE_EMPTY_BAG](state) {
    state.loading = true;
  },

  [CREATE_UPDATE_EMPTY_BAG_FAILED](state) {
    state.loading = false;
  },

  [CREATE_UPDATE_EMPTY_BAG_SUCCESS](state, data) {
    state.loading = false;
  },

  [GET_USER_BAG](state) {
    state.loading = true;
  },

  [GET_USER_BAG_FAILED](state) {
    state.loading = false;
  },

  [GET_USER_BAG_SUCCESS](state, data) {
    state.loading = false;
    state.userBag = data;
  },

  [CANCEL_USER_BAG](state) {
    state.loading = true;
  },

  [CANCEL_USER_BAG_FAILED](state) {
    state.loading = false;
  },

  [CANCEL_USER_BAG_SUCCESS](state, data) {
    state.loading = false;
    state.userBag = null;
  },

  [GET_USER_BAGS](state) {
    state.loading = true;
  },

  [GET_USER_BAGS_FAILED](state) {
    state.loading = false;
  },

  [GET_USER_BAGS_SUCCESS](state, data) {
    state.loading = false;
    state.userBags = data;
  },

  [CLUB_UPSERT](state) {
    state.loadingClub = true;
  },

  [CLUB_UPSERT_FAILED](state) {
    state.loadingClub = false;
  },

  [CLUB_UPSERT_SUCCESS](state, data) {
    state.loadingClub = false;
  },

  [GET_USER_CLUB_LIST](state) {
    state.loadingClubList = true;
  },

  [GET_USER_CLUB_LIST_FAILED](state) {
    state.loadingClubList = false;
  },

  [GET_USER_CLUB_LIST_SUCCESS](state, data) {
    state.loadingClubList = false;
    state.userClubList = data;
  },

  [RESET_BAG](state) {
    state.userBag = {};
  },

  [RESET_ALL_BAG_CLUB](state) {
    state.loading = false;
    state.loadingClub = false;
    state.loadingClubList = false;
    state.userBag = null;
    state.userBags = null;
    state.userClubList = null;
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
